// extracted by mini-css-extract-plugin
module.exports = {"pclTagline":"style_pclTagline__oMH51","pbiHeading":"style_pbiHeading__Pm2y4","pclCollapsedHeading":"style_pclCollapsedHeading___p6J8"};